import { NordcadLogo } from '../shell/NordcadLogo';

/** Shown when Entra ID is configured and the user is not yet signed in. */
export function LoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center px-6">
      <div className="w-full max-w-sm rounded-brand border border-brand-primary/10 bg-white p-8 text-center shadow-sm">
        <div className="mb-6 flex justify-center">
          <NordcadLogo />
        </div>
        <h1 className="font-heading text-xl font-bold text-brand-primary">Kontrolcenter</h1>
        <p className="mt-2 text-sm text-brand-dark/60">Log ind med din Nordcad Microsoft-konto for at fortsætte.</p>
        <a
          href="/auth/login"
          className="mt-6 inline-flex w-full items-center justify-center rounded-brand bg-brand-primary px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-brand-primary-hover"
        >
          Log ind med Microsoft
        </a>
      </div>
    </div>
  );
}
